module.exports = __webpack_public_path__ + "static/img/icon2.e7cb794.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/icon2.png
// module id = /HpP
// module chunks = 1